import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  inject,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormMode } from './form-mode.enum';
import {
  FORM_LAYOUT_TOKEN,
  FormDialogLayoutComponent,
  FormDialogServiceLayoutComponent,
  FormPageServiceLayoutComponent,
} from './form-layout/form-layout.component';

@Component({ template: '', changeDetection: ChangeDetectionStrategy.Eager, standalone: true })
export class FormContainerComponent implements AfterViewInit {
  @Input() pageTitle: string;
  @Input() breadcrumb = true;
  pageMode: FormMode = FormMode.ADD;

  @ContentChild(FORM_LAYOUT_TOKEN) formLayout:
    | FormPageServiceLayoutComponent<any>
    | FormDialogServiceLayoutComponent<any>
    | FormDialogLayoutComponent<any>;

  cd = inject(ChangeDetectorRef);

  ngAfterViewInit(): void {
    if (this.formLayout) {
      this.pageTitle = this.formLayout.pageTitle;
      this.pageMode = this.formLayout.pageMode;
      this.cd.detectChanges();
    }
  }

  get readonly(): boolean {
    return this.pageMode === FormMode.VIEW;
  }
}
